import React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Stack } from "@mui/material";

import { useSelector } from "react-redux";

import {
    HelpImage,
    SupportActionButton,
    SupportActionLabel,
    SupportCardAccent,
    SupportCardActions,
    SupportCardBody,
    SupportCardContent,
    SupportCardRoot,
    SupportCardTitle,
    SupportContactEmail,
    SupportContactName,
    SupportContactRow,
    SupportIconChip,
} from "./SupportCard.styled";

const SupportCard = ({ trackerAllEventsNum }) => {
    const language = useSelector(
        (state: any) => state.languagesState.languages,
    );

    const isPro = trackerAllEventsNum > 1000000;
    const canBookSupport = trackerAllEventsNum >= 100000;

    return (
        <SupportCardRoot>
            <SupportCardContent>
                <SupportIconChip>
                    <SupportAgentIcon />
                </SupportIconChip>

                <SupportCardTitle>
                    {isPro
                        ? language?.support_card?.pro_title ||
                          "Your Dedicated SignalSight Expert"
                        : language?.support_card?.standart_title ||
                          "Need Assistance?"}
                </SupportCardTitle>

                {isPro && (
                    <SupportContactRow>
                        <Stack sx={{ minWidth: 0 }}>
                            <SupportContactName>
                                {language?.support_card?.contact_name ||
                                    "Gürkan Aksoy"}
                            </SupportContactName>
                            <SupportContactEmail>
                                {language?.support_card?.contact_email ||
                                    "gurkan.aksoy@zzgtech.com"}
                            </SupportContactEmail>
                        </Stack>
                    </SupportContactRow>
                )}

                <SupportCardBody>
                    {canBookSupport
                        ? "We're here to help! Click the button below to schedule a support session."
                        : "We're here to help! Send us an email and we'll get back to you as soon as possible."}
                </SupportCardBody>

                <SupportCardActions>
                    {canBookSupport ? (
                        <SupportActionButton
                            type="button"
                            onClick={() =>
                                window.open(
                                    language?.support_card?.meet_link ||
                                        "https://calendly.com/d/269-vh7-ssp/zzgtech-oop",
                                    "_blank",
                                    "noreferrer",
                                )
                            }
                        >
                            <SupportActionLabel>
                                {"GET SUPPORT"}
                            </SupportActionLabel>
                            <ArrowForwardIcon sx={{ fontSize: 16 }} />
                        </SupportActionButton>
                    ) : (
                        <HelpImage
                            src="/assets/images/help@signalsight.io.svg"
                            alt="help@signalsight.io"
                        />
                    )}
                </SupportCardActions>
            </SupportCardContent>
        </SupportCardRoot>
    );
};

export default SupportCard;
